import { Form } from "./types";

export const defaultValues: Form = {
  name: "",
  website: "",
  avatar: Math.random(),
};
